export default __webpack_public_path__ + "static/media/home-freelancer-img-01.1e8c7bb0.jpg";